import { ServicePageTemplate } from "@/components/ServicePageTemplate";

export default function Entruempelung() {
  return (
    <ServicePageTemplate
      service={{
        title: "Entrümpelung",
        keyword: "Entrümpelung Berlin",
        metaTitle: "Entrümpelung Berlin | Festpreis & Termin in 48h | MIROS",
        metaDesc:
          "Professionelle Entrümpelung in Berlin zum Festpreis. Wir räumen diskret, schnell und besenrein. Kostenlose Besichtigung anfragen!",
        heroSub:
          "Wir befreien Sie von Altlasten – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901a967e20d627a9db4d.jpg",
        trustImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901a967e20d627a9dcbb.jpg",
        seoImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901bb2e956bc24f8ce86.jpg",
        faqImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a900eb2e956bc24f8c799.jpg",
        trustIntro:
          "Eine Entrümpelung steht oft am Ende eines langen Prozesses. Sei es ein Umzug, eine Räumung oder einfach der Wunsch nach mehr Platz – wir wissen, dass Sie jetzt eine schnelle und unkomplizierte Lösung brauchen. Wir nehmen Ihnen die schwere Arbeit ab, damit Sie den Kopf für wichtigere Dinge frei haben.",
        slug: "entruempelung-berlin",
        showOurWork: true,
      }}
    />
  );
}
